import createWithBsPrefix from './utils/createWithBsPrefix';
export default createWithBsPrefix('modal-footer');